import type { CashbackDetailsFromBackend } from './types';

import { URL } from '../../../constants';
import { type ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

export const getCashbackDetails = (config: ServiceConfig, accrualDate?: string) => {
  type AdapterProps = { response: CashbackDetailsFromBackend };
  const url = accrualDate ? `${URL.CASHBACK_DETAILS}?accrualDate=${accrualDate}` : URL.CASHBACK_DETAILS;

  return defaultRequestService<AdapterProps, void>(url, config.instance.get);
};
